var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-switch',{attrs:{"active-color":"#13ce66","active-text":_vm._column.shopLock ? _vm.$t('main.open') : _vm.$t('main.close')},on:{"change":_vm.addLock},model:{value:(_vm._column.shopLock),callback:function ($$v) {_vm.$set(_vm._column, "shopLock", $$v)},expression:"_column.shopLock"}})
}
var staticRenderFns = []

export { render, staticRenderFns }